<div class="pagination-indicator">
  <div *rxFor="let page of indicatorsArray$; let pageIndex = index"
       class="pagination-indicator__item"
       [class.pagination-indicator__item_active]="pageIndex === activeIndex"></div>
</div>
